import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1c36c802&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1c36c802&prod&scoped=true&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=1c36c802&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_2f37ed56e32c39bf37bd07aa5cbb5c73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c36c802",
  null
  
)

export default component.exports